module.exports = __webpack_public_path__ + "static/media/Blinker-Bold.79130441.ttf";